import * as d3 from 'd3';
import React, { useContext } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import {RegionSelectedContext} from "../../../contexts/RegionSelectedContext";
import ScatterPlot, {DataPoint} from "../../Charts/ScatterPlot";
import EuropeRecord from "../../../models/EuropeRecord";
import Branch from "../../../interfaces/Branch";
import TwoColumnsLayout from "../../TwoColumnsLayout/TwoColumnsLayout";


const ChartContainer = styled.div`
  h3 {
    margin-bottom: 10px;
  }
`;

const recordToDataPoint = (record: EuropeRecord) => {
  return {
    x: record.premiums_last_10_years,
    y: record.pct_growth_last_10_years,
    trend: record.trend,
    label: record.company_group
  };
}

const MarketAnalysisDetailComponent: React.FC<{closeDetails: () => void}> = ({closeDetails}) => {
    const { t } = useTranslation();

    // @ts-ignore
    const { europeRecords } = useContext(GlobalDataContext);
    // @ts-ignore
    const { yearSelected } = useContext(RegionSelectedContext);

    const totalRecords: EuropeRecord[] =
      europeRecords.filter((record: EuropeRecord) => record.branch === Branch.TOTAL);

    const totalDataPoints: DataPoint[] = totalRecords.map(recordToDataPoint);

    // @ts-ignore
    const xExtent: [number, number] = d3.extent(totalDataPoints.map(point => point.x));
    // @ts-ignore
    const yExtent: [number, number] = d3.extent(totalDataPoints.map(point => point.y));

    const points: DataPoint[] = totalRecords
      .filter((record: EuropeRecord) => record.year === yearSelected)
      .map(recordToDataPoint);

    return (
        <TwoColumnsLayout
          leftColumnChildren={
            <>
              <div className='back-button' onClick={ closeDetails }>
                { t('goBack') }
              </div>
              <p className={'marketAnalysisText'}>
                { t('marketAnalysis.paragraph') }
              </p>
            </>
          }
          rightColumnChildren={
            <ChartContainer>
              <h3>
                { t('marketAnalysis.scatterPlot.title', { yearStart: (yearSelected - 10), yearEnd: yearSelected }) }
              </h3>
              <ScatterPlot
                points={ points }
                isDark={ false }
                formatVerticalTicks={ (n: number) => (`${Math.round(n * 100)}%`) }
                xExtent={ xExtent }
                yExtent={ yExtent }
              />
            </ChartContainer>
          }
        />
    )
};

export default MarketAnalysisDetailComponent;
